module.exports = __webpack_public_path__ + "static/media/policememo.60ea22cd.jpeg";